import React from 'react'
const Currency = ctx => {
  const amount = (Math.round(ctx.amount * 100) / 100).toFixed(2)
  return <span>&pound;{isNaN(amount) ? '0.00' : amount}</span>
}

export default Currency
